import { useState } from 'react';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

interface CompactCollapsibleSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  defaultOpen?: boolean;
}

export default function CompactCollapsibleSection({
  title,
  children,
  className = '',
  defaultOpen = false
}: CompactCollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex w-full items-center justify-between rounded-lg bg-zinc-50 dark:bg-zinc-800/60 px-3 py-2 text-sm font-medium text-zinc-900 dark:text-zinc-100 hover:bg-zinc-100 dark:hover:bg-zinc-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/40"
      >
        <span>{title}</span>
        {isOpen ? (
          <ChevronDownIcon className="h-4 w-4 text-zinc-500 dark:text-zinc-400" />
        ) : (
          <ChevronRightIcon className="h-4 w-4 text-zinc-500 dark:text-zinc-400" />
        )}
      </button>
      
      {isOpen && (
        <div className="mt-2">
          {children}
        </div>
      )}
    </div>
  );
} 